import { storage } from '../data/localStorage';

export const questionService = {
  // Get all questions (with team workspace support)
  async getQuestions(workspaceId) {
    try {
      // Since we don't have Supabase configured, fallback to localStorage
      return storage.getQuestions();
    } catch (error) {
      console.error('Error fetching questions:', error);
      // Fallback to localStorage
      return storage.getQuestions();
    }
  },

  // Add single question
  async addQuestion(questionData, workspaceId, userId) {
    try {
      // Since we don't have Supabase configured, fallback to localStorage only
      return storage.addQuestion(questionData);
    } catch (error) {
      console.error('Error adding question:', error);
      // Fallback to localStorage only
      return storage.addQuestion(questionData);
    }
  },

  // Add multiple questions (for Excel upload)
  async addMultipleQuestions(questionsData, workspaceId, userId) {
    try {
      // Since we don't have Supabase configured, fallback to localStorage only
      const addedQuestions = [];
      questionsData.forEach(questionData => {
        const added = storage.addQuestion(questionData);
        addedQuestions.push(added);
      });
      return addedQuestions;
    } catch (error) {
      console.error('Error adding multiple questions:', error);
      // Fallback to localStorage only
      const addedQuestions = [];
      questionsData.forEach(questionData => {
        const added = storage.addQuestion(questionData);
        addedQuestions.push(added);
      });
      return addedQuestions;
    }
  },

  // Update question
  async updateQuestion(questionId, updatedData, workspaceId) {
    try {
      // Since we don't have Supabase configured, fallback to localStorage only
      storage.updateQuestion(questionId.toString(), updatedData);
      return null;
    } catch (error) {
      console.error('Error updating question:', error);
      // Fallback to localStorage only
      storage.updateQuestion(questionId.toString(), updatedData);
      return null;
    }
  },

  // Delete question
  async deleteQuestion(questionId, workspaceId) {
    try {
      // Since we don't have Supabase configured, fallback to localStorage only
      storage.deleteQuestion(questionId.toString());
      return true;
    } catch (error) {
      console.error('Error deleting question:', error);
      // Fallback to localStorage only
      storage.deleteQuestion(questionId.toString());
      return false;
    }
  },

  // Sync localStorage to Supabase (for migration)
  async syncLocalToSupabase(workspaceId, userId) {
    try {
      // Since we don't have Supabase configured, this is a no-op
      console.log('Supabase not configured, sync skipped');
      return null;
    } catch (error) {
      console.error('Error syncing local questions to Supabase:', error);
      return null;
    }
  }
};